import { handleActions } from 'redux-actions';
import { push } from "react-router-redux";
import { initialize as initializeForm } from 'redux-form';
import { NotificationManager } from "react-notifications";
import { api } from "api";


const LISTADO_PRECIOS = 'LISTADO_PRECIOS';
const LOADER = 'LOADER';
const PARAMETRO = 'PARAMETRO';
const MODULO = 'MODULO';

const setLoader = loader => ({
    type: LOADER,
    loader,
});

export const listar = () => (dispatch) => {
    let ruta = window.location.href;
    let id_emp = ruta.split('/');
    let id = id_emp[5];
    const params = { id };
    dispatch(setLoader(true));
    api.get('/rrhh_listado_precios', params).then((response)=>{
        dispatch({ type: LISTADO_PRECIOS, data: response });
    }).catch((error)=>{
        NotificationManager.error(
            'Ocurrió un error al listar precios',
            'Error',
            0
        );
    }).finally(() => {
        dispatch(setLoader(false));
    });
}

export const registroPrecio = () => (dispatch, getStore) => {
    let ruta = window.location.href;
    let id_emp = ruta.split('/');
    const data = getStore().form.FormListadoPreciosRH.values;
    const formData = {
        sku: data.sku,
        producto: data.producto,
        precio: data.precio,
        empresa: id_emp[5],
    }
    dispatch(setLoader(true));
    api.post('/rrhh_listado_precios/', formData).then((response) => {
        dispatch(initializeForm('FormListadoPreciosRH', response));
        NotificationManager.success(
            'Precio ingresado correctamente',
            'Exito',
            3000
        );
        
    }).catch((error) => {
        NotificationManager.error(
            error.msj,
            'Error',
            2000
        );
    }).finally(() => {
        dispatch(setLoader(false));
    });
}           

export const modificarPrecio = () => (dispatch, getStore) => {
    let ruta = window.location.href;
    let id_emp = ruta.split('/');
    const datos = getStore().form.FormListadoPreciosRH.values;
    const id = datos.id;
    const formData = {
        id: id,
        sku: datos.sku,
        producto: datos.producto,
        precio: datos.precio
    }
    dispatch(setLoader(true));
    api.put(`/rrhh_listado_precios/${id}/`, formData).then(() => {
        NotificationManager.success(
            'Precio modificado correctamente',
            'Exito',
            3000
        );
        let ruta = `/rr_hh/${id_emp[5]}/listado_precios`
        dispatch(push(ruta));
    }).catch((error) => {
        NotificationManager.error(
            error.msj,
            'Error',
            2000
        );
    }).finally(() => {
        dispatch(setLoader(false));
    });
}

export const leer = (id) => (dispatch) => {
    dispatch(setLoader(true));
    api.get(`/rrhh_listado_precios/${id}`).then((response) => {
        dispatch(initializeForm('FormListadoPreciosRH', response));
    }).catch(()=>{
        NotificationManager.error(
            'Ocurrió un error al consultar listado de precios',
            'Error',
            2000
        );
    }).finally(() => {
        dispatch(setLoader(false));
    });

}


export const parametrosEmpresa = () => (dispatch) => {
    let ruta = window.location.href;
    let id_emp = ruta.split('/');
    let id = id_emp[5];
    let params = {id}
    dispatch(setLoader(true));
    api.get('/empresa/empresa_parametros', params).then((response) => {
        dispatch({type: PARAMETRO, datos: response });
    }).catch((error)=>{
        NotificationManager.error(
            'Ocurrió un error al consultar parametros',
            'Error',
            8000
        );
    }).finally(() => {
        dispatch(setLoader(false));
    });

}

export const getModulo = (id, modulo) => (dispatch) => {
    const params = {id, modulo}
    dispatch(setLoader(true));
    api.get('/modulos/modulo/', params).then((response)=>{
        dispatch({ type: MODULO, modulo: response.modulos });
    }).catch(() => {
        NotificationManager.error(
            'Ocurrió un error en buscar modulo',
            'Error',
            2000
        );
    }).finally(() => {
        dispatch(setLoader(false));
    });
};

export const actions = {
    listar,
    registroPrecio,
    modificarPrecio,
    leer,
    getModulo,
    parametrosEmpresa,
};

export const reducers = {
    [LOADER]: (state, { loader }) => {
        return {
            ...state,
            loader,
        };
    },
    [LISTADO_PRECIOS]: (state, { data }) => {
        return {
            ...state,
            data,
        };
    },
    [PARAMETRO]: (state, { datos }) => {
        return {
            ...state,
            datos,
        };
    },
    [MODULO]: (state, { modulo }) => {
        return {
            ...state,
            modulo,
        };
    },
};

export const initialState = {
    loader: false,
    datos: [],
    modulo: [],
    data: [],
    page: 1,
};

export default handleActions(reducers, initialState)